import { TableCell, Typography } from "@mui/material";
import { Avatar } from "../../../../../components/fieldsViews/fields/Avatar";
import { ServiceProvided } from "../../types";


type CreatedByUserTableCellProps = {
	serviceProvided: ServiceProvided;
};

export const CreatedByUserTableCell = ({
	serviceProvided,
}: CreatedByUserTableCellProps) => {
	return (
		<TableCell align="center" sx={{display: "flex", flexDirection:"row", alignItems: "center", justifyContent:"center", gap:2}}>
			<Avatar value={serviceProvided?.user_created?.id} />
			<Typography variant="body1">
				{serviceProvided.user_created.first_name + " " + serviceProvided.user_created.last_name}
			</Typography>
		</TableCell>
	);
};

